import type { Template } from "@/types";

export const LA_07_H3_V4: Template[] = [
    {
        id: "la-07-h3v4-01",
        name: "LA 01 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 108, y: 206, width: 461, height: 280, rotation: 0, imageRotation: 0 },
            { id: "2", x: 108, y: 45, width: 227, height: 153, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 45, width: 227, height: 153, rotation: 0, imageRotation: 0 },
            { id: "4", x: 843, y: 45, width: 168, height: 217, rotation: 0, imageRotation: 0 },
            { id: "5", x: 843, y: 270, width: 168, height: 216, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1019, y: 45, width: 167, height: 217, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 270, width: 167, height: 216, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-02",
        name: "LA 02 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 79, y: 45, width: 198, height: 141, rotation: 0, imageRotation: 0 },
            { id: "2", x: 79, y: 194, width: 198, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 79, y: 344, width: 198, height: 141, rotation: 0, imageRotation: 0 },
            { id: "4", x: 285, y: 45, width: 304, height: 440, rotation: 0, imageRotation: 0 },
            { id: "5", x: 782, y: 45, width: 302, height: 440, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1091, y: 45, width: 146, height: 216, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1091, y: 269, width: 146, height: 216, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-03",
        name: "LA 03 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 110, y: 46, width: 454, height: 283, rotation: 0, imageRotation: 0 },
            { id: "2", x: 110, y: 336, width: 224, height: 152, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 336, width: 223, height: 152, rotation: 0, imageRotation: 0 },
            { id: "4", x: 804, y: 44, width: 299, height: 445, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1111, y: 44, width: 113, height: 143, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1111, y: 195, width: 113, height: 143, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1111, y: 346, width: 113, height: 142, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-04",
        name: "LA 04 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 47, y: 64, width: 181, height: 130, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 201, width: 181, height: 130, rotation: 0, imageRotation: 0 },
            { id: "3", x: 47, y: 339, width: 181, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 236, y: 64, width: 252, height: 403, rotation: 0, imageRotation: 0 },
            { id: "5", x: 495, y: 64, width: 134, height: 198, rotation: 0, imageRotation: 0 },
            { id: "6", x: 495, y: 270, width: 134, height: 197, rotation: 0, imageRotation: 0 },
            { id: "7", x: 855, y: 40, width: 317, height: 451, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-05",
        name: "LA 05 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 226, y: 42, width: 224, height: 145, rotation: 0, imageRotation: 0 },
            { id: "2", x: 226, y: 195, width: 224, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 226, y: 347, width: 224, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 856, y: 42, width: 155, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 856, y: 271, width: 155, height: 221, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 42, width: 155, height: 221, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 271, width: 155, height: 221, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-06",
        name: "LA 06 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 58, y: 44, width: 304, height: 204, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 256, width: 148, height: 232, rotation: 0, imageRotation: 0 },
            { id: "3", x: 214, y: 256, width: 148, height: 232, rotation: 0, imageRotation: 0 },
            { id: "4", x: 370, y: 44, width: 303, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 370, y: 256, width: 147, height: 232, rotation: 0, imageRotation: 0 },
            { id: "6", x: 525, y: 256, width: 147, height: 232, rotation: 0, imageRotation: 0 },
            { id: "7", x: 680, y: 44, width: 613, height: 445, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-07",
        name: "LA 07 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 58, width: 285, height: 413, rotation: 0, imageRotation: 0 },
            { id: "2", x: 292, y: 58, width: 283, height: 413, rotation: 0, imageRotation: 0 },
            { id: "3", x: 583, y: 58, width: 285, height: 413, rotation: 0, imageRotation: 0 },
            { id: "4", x: 875, y: 58, width: 187, height: 133, rotation: 0, imageRotation: 0 },
            { id: "5", x: 875, y: 198, width: 187, height: 133, rotation: 0, imageRotation: 0 },
            { id: "6", x: 875, y: 339, width: 187, height: 133, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1069, y: 58, width: 283, height: 413, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-08",
        name: "LA 08 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 59, y: 44, width: 613, height: 445, rotation: 0, imageRotation: 0 },
            { id: "2", x: 680, y: 44, width: 304, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 991, y: 44, width: 303, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 680, y: 256, width: 148, height: 232, rotation: 0, imageRotation: 0 },
            { id: "5", x: 835, y: 256, width: 148, height: 232, rotation: 0, imageRotation: 0 },
            { id: "6", x: 991, y: 256, width: 148, height: 232, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1146, y: 256, width: 148, height: 232, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-09",
        name: "LA 09 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 45, width: 280, height: 440, rotation: 0, imageRotation: 0 },
            { id: "2", x: 288, y: 45, width: 203, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 288, y: 194, width: 203, height: 141, rotation: 0, imageRotation: 0 },
            { id: "4", x: 288, y: 344, width: 203, height: 141, rotation: 0, imageRotation: 0 },
            { id: "5", x: 498, y: 45, width: 280, height: 440, rotation: 0, imageRotation: 0 },
            { id: "6", x: 785, y: 45, width: 279, height: 440, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1072, y: 45, width: 279, height: 440, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-10",
        name: "LA 10 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 45, width: 280, height: 440, rotation: 0, imageRotation: 0 },
            { id: "2", x: 288, y: 45, width: 279, height: 440, rotation: 0, imageRotation: 0 },
            { id: "3", x: 575, y: 45, width: 279, height: 440, rotation: 0, imageRotation: 0 },
            { id: "4", x: 862, y: 45, width: 279, height: 440, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1149, y: 45, width: 203, height: 141, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1149, y: 195, width: 203, height: 140, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1149, y: 345, width: 203, height: 140, rotation: 0, imageRotation: 0 }
        ],
    }
];